import script from "./CustomerSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerSearch.vue?vue&type=script&setup=true&lang=js"

import "./CustomerSearch.vue?vue&type=style&index=0&id=a9c75702&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9c75702"]])

export default __exports__